import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M14.5,10.25a.25.25,0,0,0-.25.25v3c0,.28.5.28.5,0v-3A.25.25,0,0,0,14.5,10.25Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M19,10.75a.25.25,0,1,0,.25.25A.25.25,0,0,0,19,10.75Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M23.78,6.81,17.19.22A.75.75,0,0,0,16.66,0H7.34a.75.75,0,0,0-.53.22L.22,6.81A.75.75,0,0,0,0,7.34v9.32a.75.75,0,0,0,.22.53l6.59,6.59a.75.75,0,0,0,.53.22h9.32a.75.75,0,0,0,.53-.22l6.59-6.59a.75.75,0,0,0,.22-.53V7.34A.75.75,0,0,0,23.78,6.81ZM6,11.4a2.56,2.56,0,0,1,1.3,2.1A1.76,1.76,0,0,1,5.5,15.25h-1a.75.75,0,0,1,0-1.5h1a.25.25,0,0,0,.25-.25c0-.34-.19-.52-.7-.9a2.56,2.56,0,0,1-1.3-2.1A1.76,1.76,0,0,1,5.5,8.75h1a.75.75,0,0,1,0,1.5h-1a.25.25,0,0,0-.25.25C5.25,10.84,5.44,11,6,11.4ZM11,10.25a.25.25,0,0,0-.25.25v4a.75.75,0,0,1-1.5,0v-4A.25.25,0,0,0,9,10.25a.75.75,0,0,1,0-1.5h2a.75.75,0,0,1,0,1.5Zm5.25,3.25a1.75,1.75,0,0,1-3.5,0v-3a1.75,1.75,0,0,1,3.5,0Zm2.7-.31a.26.26,0,0,0-.2.25V14.5a.75.75,0,0,1-1.5,0v-5A.76.76,0,0,1,18,8.75h.5A2.24,2.24,0,0,1,19,13.19Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }